/* Which market and which processor an order belongs to.
 *
 * WHY THIS IS NOT JUST `order.country`. Malaysian orders carry neither field.
 * They are written by payment-webhook.js — the shared Curlec webhook that
 * predates both fields and serves the v1 checkout and v2 alike — so the home
 * market arrives with country and gateway both absent.
 *
 * That absence is a FACT, not missing data: Curlec has exactly one market and
 * always will, because every country added since is on Stripe. So it can be
 * resolved rather than displayed as "unknown", which is what the sales
 * dashboard was about to call the biggest market in the business.
 *
 * IT LIVES HERE BECAUSE IT WAS ALREADY WRONG IN TWO PLACES. The admin screen
 * resolved it and the revenue endpoint did not, so the same order rendered as
 * Malaysia on one and "unknown" on the other, and ?country=my returned nothing
 * at all. Two copies of a two-line rule is all it took. src/utils/orders.js is
 * a symlink to this file, the same arrangement countries.js and fees.js use.
 *
 * NOTHING IS GUESSED. A Stripe order with no country stays null — we have seen
 * real ones, charged outside createOrderV2, and inventing a market for them
 * would put revenue in a country that never sold anything.
 */

/* Absent country + absent gateway => the Curlec webhook wrote it => Malaysia.
 * Any other combination is left exactly as recorded. */
function countryOf(order) {
  if (!order) return null;
  if (order.country) return order.country;
  return order.gateway ? null : "my";
}

function gatewayOf(order) {
  if (!order) return null;
  if (order.gateway) return order.gateway;
  return order.country ? null : "curlec";
}

module.exports = { countryOf, gatewayOf };
